import {
  LOAD_ACTIVITY_FEED,
  LOAD_MORE_ACTIVITY_FEED_POSTS,
  LOAD_ACTIVITY_FEED_ERROR,
} from "../actions/types";

const initialState = {
  posts: [],
  totalCount: 0,
  loaded: 0,
  loading: true,
  isPortalUser: false,
  hasMore: true,
  errors: null,
};

export default function activityFeedReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_ACTIVITY_FEED:
      return {
        ...state,
        loading: false,
        isPortalUser: payload.isPortalUser,
        posts: payload.posts,
        totalCount: payload.totalCount,
        loaded: payload.loaded,
        page: 2,
        errors: null,
      };
    case LOAD_MORE_ACTIVITY_FEED_POSTS:
      return {
        ...state,
        loading: false,
        posts: state.posts.concat(payload.newPosts),
        page: state.page + 1,
        loaded: state.loaded + payload.perPageCount,
        hasMore: !(state.loaded >= state.totalCount),
        errors: null,
      };
    case LOAD_ACTIVITY_FEED_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    default:
      return state;
  }
}
